var chunkToChildrenMap = {
	"src_pages_PlayDemo_jsx": [
		"src_components_ContentTray_ContentTray_jsx",
		"src_components_DrugLabMap_DrugLabMap_jsx"
	],
	"src_components_DrugLabMobileDemo_DrugLabMobileDemo_jsx": [
		"vendors-node_modules_debug_src_browser_js",
		"vendors-node_modules_katex_dist_katex_min_css",
		"vendors-node_modules_react-markdown_lib_index_js",
		"vendors-node_modules_rehype-katex_lib_index_js-node_modules_remark-math_lib_index_js",
		"vendors-node_modules_react-katex_dist_react-katex_js",
		"vendors-node_modules_html-to-image_es_index_js",
		"vendors-node_modules_html2canvas_dist_html2canvas_js",
		"src_components_Slide_DiagramPreview_jsx",
		"src_components_MarkdownRenderer_jsx",
		"src_data_usStatesGeo_js",
		"src_components_Slide_SlideContent_jsx",
		"src_components_Slide_SlideViewer_jsx",
		"src_api_teaching_js",
		"src_components_Boss_MatchingGame_jsx-src_components_Quiz_MCQOptions_jsx-src_components_Quiz_Q-168626",
		"src_components_RichText_RichText_jsx",
		"src_components_ConceptCard_ConceptCardRenderer_jsx",
		"src_components_Diamond_DiamondSession_css",
		"src_api_combat_js",
		"src_components_ConceptCard_DrillFillBlank_jsx-src_components_ConceptCard_DrillMCQ_jsx-src_com-e11aab",
		"src_components_ConceptCard_DrillRatingWidget_jsx",
		"src_api_cram_js",
		"src_pages_ConceptBlockDrill_css",
		"src_components_ConceptTray_WorkshopOverlay_jsx",
		"src_hooks_useProgressInvalidation_js",
		"src_components_Citation_CitationCard_jsx",
		"src_components_KeystonePickModal_KeystonePickModal_jsx",
		"src_components_Achievements_AchievementIcons_jsx",
		"src_components_Apothecarius_Apothecarius_jsx-src_components_Combat_GuidelineCitations_jsx-src-95b359",
		"src_components_BugReportModal_jsx",
		"src_components_Boss_CombatResultModal_jsx",
		"src_components_Boss_HPBar_jsx",
		"src_components_FirstCombatGate_FirstCombatGate_jsx",
		"src_pages_BatchBossSession_jsx"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));